import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';
import { OrderDetail, OrderDetailPayload } from '../models/order-detail.model';

@Injectable({ providedIn: 'root' })
export class OrderDetailService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.API_ORDERS}`;

  async getOrderDetail(payload: OrderDetailPayload): Promise<OrderDetail | null> {
    try {
      const response = await firstValueFrom(
        this.http.get<OrderDetail>(
          `${this.endpoint}/v2/${payload.tenantId}/orders/${payload.orderId}/detail?orderType=${payload.orderType}`
        )
      );
      return response;
    } catch (error) {
      return null;
    }
  }
}
